let printer_BillPrintActions = require("../../templates/printer/BillPrintActions.handlebars");
let cashier_CashierView = require("../../templates/cashier/CashierView.handlebars");
let NumberPad = require("../../templates/NumberPad.handlebars");
let Membership_selectorView = require("../../templates/cashier/MembershipSelectorView.handlebars");
let Discount_selectorView = require("../../templates/cashier/DiscountSelectorView.handlebars");
let Payment_selectorView = require("../../templates/cashier/PaymentSelectorView.handlebars");
let Currency_choose = require("../../templates/cashier/CurrencyChoose.handlebars");

let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
let BillModel = require("../../model/BillModel.js");
import ModalView from "../comp/ModalView.js";
import NumberPadView from "../comp/NumberPadView.js";
import DiscountSelectorView from "./DiscountSelectorView.js";
import CurrencySelectorView from "./CurrencySelectorView.js";
import MembershipSelectorView from "./MembershipSelectorView.js";
import POS from "../../POS.js";
import TableSelectModalView from "../comp/TableSelectModalView.js";
import BillItemEditView from "../order/BillItemEditView.js";
import i18n from "../../utils/i18n";
import BillPrintActionsView from "../printer/BillPrintActionsView.js";
import PrintService from "../../service/PrintService.js";

let DbRecorder = require("../../recorder/DbRecorder.js");
let ChooseMemberModalView = require("../ChooseMemberModalView.js");
let {LogUtil} = require('../../utils/utils');
let i = require("i18next");
let PaymentSelectorView = require("./PaymentSelectorView.js");

let main = function () {
        return Backbone.View.extend({
                billItemEditView: null,
                chooseMemberModalView: null,
                BillPrintActionsView: null,
                discountSelector: null,
                paymentSelectorView: null,
                tableSelectModalView: null,
                events: {
                    "keyup": "_checkKey",
                    "click span.table-info": "_switchTable",
                    "click .discounts .add-discount,.discount-area:not(.has-discount),.ignore-area:not(.has-discount),.tip-area:not(.has-discount)": "_showDiscounts",
                    "click .btn.pay": "_payBill",
                    "click .modes .mode": "_choosePayMode",
//                "click .ignore": "_updateIgnore",
                    "click .ignore-area .remove": "_removeIgnore",
                    "click .discount-area .remove": "_removeDiscount",
                    "click .tip-area .remove": "_removeTip",
                    "click .pay-notes .deletenote": "_removeNote",
                    "click textarea.note": "trackNoteEvent",
                    "click .cashier-note .add-btn,.pay-notes:not(.deletenote)": "_showAddNotes",
                    "click .print-invoice": "_printBillInTab",
                    'click .billItem': "_chooseItem",
                    'click .service-item': '_toggleFee',
                    'click .cashier-print .choose-waiter': 'chooseWaiter',
                    "click .cashier-print .delete-waiter": "_removeWaiter",
                    'click .amount-item.change': '_payBillNoChange',
                    'click .functionTabs .billView': 'showBillView',
                    'click .functionTabs .discountView': 'showDiscountView',
                    'click .functionTabs .calculatorView': 'showCalculatorView',
                    "click .add-booking:not(.deletebooking)": "_addBooking",
                    "click .booking-notes .deletebooking": "_removeBooking",
                },

                printEL: null,

                // 初始化
                initialize: function () {
                    var self = this;
                    if (!self.model) {
                        self.model = new Backbone.Model();
                    }
                    self.model.on("change:tableId", self._onTableChange, self);
                    self.model.on("change:discountId", self._onDiscountChange, self);
                    self.model.on("change:singeDiscount", self._onSingeDiscountChange, self);
                    self.model.on("change:membershipid", self._onMembershipChange, self);
                    self.model.on("change:useignore", self._onIgnoreChange, self);
                    self.model.on("change:usetip", self._onTipChange, self);
                    if (!self.printEL) {
                        self.printEL = $(printer_BillPrintActions());
                    }

                    var symbol = POS.getRestaurant().get("currencySymbol"),
                        discounts = _.map(POS.get("discountCollection").getValidDiscounts(), function (model) {
                            var json = model.toJSON();
                            json._off = (json.type == "Amount") ? (symbol + json.off) : (json.off + "%");
                            return json;
                        });
                    var discountSelectorEl = $(Discount_selectorView({
                        discounts: discounts,
                        admins: POS.getRestaurantAdmins()
                    }));
                    this.discountSelector = new DiscountSelectorView({el: discountSelectorEl, model: self.model});


                    var restaurant = POS.getRestaurant(), params = {
                        used: {}
                    };
                    _.each(restaurant.get("defaultPaymentMethods"), function (method) {
                        if (method.inUse) {
                            params.used[method.method] = method.method;
                        }
                    });
                    params.customPayments = POS.get("customPayments");
                    var paymentSelectorEl = $(Payment_selectorView(params));
                    this.paymentSelectorView = new PaymentSelectorView({
                        el: paymentSelectorEl,
                        model: self.model,
                        numberpad: self.numberpad
                    });

                    this.tableSelectModalView = new TableSelectModalView({
                        collection: new Backbone.Collection(POS.getOrderingTables()),
                        currentTable: POS.getTables().get(this.model.get("tableId"))
                    });
                },
                _toggleFee: function (evt) {
                    var self = this, item = $(evt.currentTarget),
                        bill = self.model.get('currentBill'), originalBill = self.model.get('currentOriginalBill'),
                        cancelFee = item.hasClass('cancel-fee');
                    cancelFee ? item.removeClass('cancel-fee') : item.addClass('cancel-fee');
                    console.log('cancelFee', !cancelFee);
                    bill.set({noFee: !cancelFee});
                    originalBill.set({noFee: !cancelFee});
                    bill.calculateAmount();
                    self._updateAmounts();
                },
                _activeItem: function (item) {
                    item.addClass('selected');
                    item.find(".info").animate({left: 10}, 0);
                },
                _hideItem: function (item) {
                    if (!item) {
                        this.$('.billItem.selected').find(".info").animate({left: 0}, 100);
                        this.$('.billItem').removeClass('selected');
                        return;
                    }
                    item.removeClass('selected');
                    item.find(".info").animate({left: 0}, 100);
                },
                _chooseItem: function (event) {
                    var self = this, tableId = self.model.get("tableId"), table, restaurant, bill;
                    if ($(event.target).hasClass('edit-quantity') && $('.billItemEdit .closeBillItemEdit').size() == 0) {
                        return;
                    } else {
                        var item = $(event.target).closest(".billItem");
                        var status = 'show';
                        if (item.hasClass('selected')) {
                            this.$('.billItem.selected').find(".info").animate({left: 0}, 100);
                            this.$('.billItem').removeClass('selected');
                            status = 'close';
                        } else {
                            this.$('.billItem.selected').find(".info").animate({left: 0}, 100);
                            this.$('.billItem').removeClass('selected');
                            item.addClass('selected');
                            item.find(".info").animate({left: 10}, 100);
                        }
                        if (!tableId || (tableId < 1)) {
                            POS.setCurrentTable(null);
                            return;
                        }
                        table = POS.getTable(tableId);
                        POS.setCurrentTable(table);
                        if (self.model.get("billId")) {
                            bill = table.getActiveBillCollection().get(self.model.get("billId"));
                            if (!bill) {
                                self.model.unset("billId")
                            }
                        }
                        if (!bill) {
                            bill = table.getCurrentBill();
                        }
                        var selectedBillItem = bill.getBillItems().findWhere({priority: item.data("priority")});
                        if (status == 'close') {
                            self.onCloseBillItemEditView();
                        } else {
                            if (selectedBillItem) {
                                self.billItemEditView.model = selectedBillItem;
                                self.billItemEditView.model.set({symbol: POS.get("restaurantModel").get("currencySymbol")});
                                self.billItemEditView.render();
                                self.listenTo(self.billItemEditView, "close", self.onCloseBillItemEditView);
                                self.listenTo(self.billItemEditView, 'changeDiscount', self.onChangeDiscounts);
                            }
                        }
                    }
                },
                onCloseBillItemEditView: function () {
                    this.$('.billItemEdit').hide();
                    this.$('.billItem.selected').find(".info").animate({left: 0}, 100);
                    this.$('.billItem').removeClass('selected');
                },
                onChangeDiscounts: function (onSingeChange) {
                    this._onTableChange(onSingeChange);
                },
                render: function (options) {
                    var tableId, billId;
                    var printerStatus = POS.get("printSettingModel").get("paymentReceipt") == false;
                    if (options) {
                        if (typeof options == 'object') {
                            this.model.set({tableId: options.tableId, billId: (options.billId || 0)});
                        } else {
                            this.model.set({tableId: options, billId: 0});
                        }
                    }
                    if (!this.model.get("tableId")) {
                        var currentTable = _.first(POS.getOrderingTables());
                        if (currentTable) {
                            this.model.set({tableId: currentTable.id});
                        }
                    }
                    if (!this.model.get("tableId")) {
                        POS.setCurrentTable(null);
                        this._switchTable();
                    } else {
                        tableId = this.model.get("tableId");
                        billId = this.model.get("billId");
                        this.model.unset("tableId");
                        this.model.set({tableId: tableId, billId: billId});
                    }
                    this._checkBillMembership();
                },
                onSelectClose: function () {
                    if (this.model.get("tableId")) {
                        Backbone.history.navigate("table/" + this.model.get("tableId"), {trigger: true});
                    } else {
                        Backbone.history.navigate("overview", {trigger: true});
                    }
                },
                _onChangeTable: function (table) {
                    if (table) {
                        this.model.set("tableId", table.id);
                    } else if (this.model.get("tableId") == null) {
                        Backbone.history.navigate("overview", {trigger: true});
                    }
                    if (this.model.get("tableId")) {
                        Backbone.history.navigate("table/" + this.model.get("tableId"), {trigger: true});
                    } else {
                        Backbone.history.navigate("overview", {trigger: true});
                    }
                },
                _onTableChange: function (onSingeChange) {
                    var self = this, tableId = self.model.get("tableId"), table, restaurant, bill, discount, singeDiscount,
                        ignoreAmount, tipAmount;
                    if (!tableId || (tableId < 1)) {
                        POS.setCurrentTable(null);
                        return;
                    }

                    let parentEl = self.$el.parent();
                    self.$el.detach();
                    self.$el.empty();

                    table = POS.getTable(tableId);
                    POS.setCurrentTable(table);
                    restaurant = POS.get("restaurantModel");
                    if (self.model.get("billId")) {
                        bill = table.getActiveBillCollection().get(self.model.get("billId"));
                        if (!bill) {
                            self.model.unset("billId")
                        }
                    }
                    if (!bill) {
                        bill = table.getCurrentBill();
                    }
                    if (onSingeChange && typeof onSingeChange == "boolean") {
                        bill.unset("discount", {silent: true});
                        bill.unset("discountId", {silent: true});
                    }
                    discount = bill.get("discount");
                    ignoreAmount = bill.get("ignoreAmount");
                    tipAmount = bill.get("tipAmount");
                    bill.calculateAmount();
                    self.model.set({currentBill: new BillModel(DbRecorder.convert2JSON(bill))});
                    self.model.set({currentOriginalBill: bill});
                    bill.set("restaurant", DbRecorder.convert2JSON(restaurant));
                    var params = {paidAmount: 0, changeAmount: (0 - bill.getShouldPayAmount())};
                    params.billItems = [];
                    if (restaurant.get("defaultPaymentMethods") && restaurant.get("defaultPaymentMethods").length > 0) {
                        _.each(restaurant.get("defaultPaymentMethods"), function (method) {
                            if (method.inUse) {
                                params.defaultMethods = true;
                                if (method.customPayment) {
                                    _.each(POS.get("customPayments"), function (payment) {
                                        if (payment.id == method.customPayment.id) {
                                            payment["defaultChoose"] = true;
                                        }
                                    });
                                } else {
                                    params[method.method] = method.method;
                                }
                            }
                        });
                        params.customPayments = POS.get("customPayments");
                    } else {
                        params.defaultMethods = false;
                        params.customPayments = POS.get("customPayments");
                    }
                    _.each(bill.getBillItems().toJSON(), function (item) {
                        if (item.orderedQuantity != 0) {
                            item.menuItemName = item.menuItem.status == 'Unavailable' ? item.menuItem.name.split('-')[1] + i18n.msg('pos.menu.item.delete') : item.menuItem.name;
                            params.billItems.push(item);
                        }
                    });
                    // 统计餐品数量  不包含退菜
                    // params.billItemCount = bill.getBillItems().length;
                    var billItemCount = 0;
                    $.each(bill.get("items").models, function (index, item) {
                        console.log("餐品的数量items:", item);
                        // 判断退菜
                        if (!item.attributes.hasRefund || item.attributes.quantity != item.attributes.refundQuantity) {
                            billItemCount++;
                        }
                        var sDiscount = DbRecorder.convert2JSON(item.get("discount"));
                        if (sDiscount && sDiscount.singe) {
                            singeDiscount = sDiscount;
                            params.singeDiscount = "singeDiscount";
                        }
                    });
                    params.billItemCount = billItemCount;
                    params.disabledPaymentStatus = POS.get("printSettingModel").get("paymentReceipt") == false ? "disabledPayment" : "";
                    _.extend(params, {table: table.toJSON(), restaurant: restaurant.toJSON(), bill: bill.toJSON()});
                    params.cid = bill.cid;
                    params.symbol = POS.get("restaurantModel").get("currencySymbol");
                    self.model.set({billId: bill.id});
                    var cashierContainer = $(cashier_CashierView(params));
                    var numberPadView = $(NumberPad({
                        closest: ".cashier-container",
                        targets: ".modes .mode",
                        selected: "selected"
                    }));
                    cashierContainer.find(".numberpad-container").append(numberPadView);
                    self.numberpad = new NumberPadView({
                        el: numberPadView,
                        model: new Backbone.Model({type: "mutual", leftPay: self._leftPay()})
                    });
                    self.$el.append(cashierContainer);
                    self.billItemEditView = new BillItemEditView({el: self.$(".cashier-container")});
                    self.stopListening();
                    self.listenTo(self.numberpad.model, "change:number", self._onNumberChange);
                    self._onNumberChange();
                    self._checkDiscount();
                    if (table.get("currentBill").get("note")) {
                        self.note = table.get("currentBill").get("note");
                        params.note = self.note;
                        self.$('.add-btn').hide().siblings('.pay-notes').css('display', 'block').show().find('.content').text(self.note);
                    }
                    if (table.get("currentBill").get("waiter")) {
                        self.waiter = table.get("currentBill").get("waiter");
                        self.$('.add-waiter').hide().siblings('.show-waiter').css('display', 'inline-table').show().find('.name').text(self.waiter.name);
                    }
                    self.model.set({singeDiscount: singeDiscount});
                    if (singeDiscount) {
                        self._updateSingeDiscountHtml(singeDiscount);
                    } else if (discount) {
                        self.model.set({discount: discount});
                        self.model.set({discountId: discount.id});
                        discount = POS.get("discountCollection").get(discount.id);
                        bill.set({discount: discount});
                        self._updateDiscountHtml(DbRecorder.convert2JSON(discount));
                    } else {
                        self.model.unset("discount", {silent: true});
                        self.model.unset("discountId", {silent: true});
                        self._updateSingeDiscountHtml(null);
                    }
                    if (ignoreAmount > 0) {
                        self.model.set({useignore: true, ignoreAmount: ignoreAmount});
                        bill.set({ignoreAmount: ignoreAmount});
                        self._updateIgnoreHtml(ignoreAmount);
                    } else {
                        self.model.unset("useignore");
                    }
                    if (tipAmount > 0) {
                        self.model.set({usetip: true, tipAmount: tipAmount});
                        bill.set({tipAmount: tipAmount});
                        self._updateTipHtml(tipAmount);
                    } else {
                        self.model.unset("usetip");
                    }
                    if (self._leftPay() <= 0) {
                        self.$('.cashier-container .pay.btn').removeClass('disabled').attr("disabled", null);
                    } else {
                        self.$('.cashier-container .pay.btn').addClass('disabled').attr("disabled", "disabled");
                    }
                    parentEl.append(this.$el);
                    _.delay(() => {
                        self.numberpad._focusNumberInput();
                    }, 0);
                },
                _onNumberChange: function () {
                    console.log('CashierView onNumberChange');
                    var self = this;
                    if (self.numberpad.target) {
                        var amount = self.numberpad.model.get("number").toFixed(2);

                        // if mode is Member card, but card credit less than amount.
                        if (self.numberpad.target.data("mode") == "MEMBER_CARD") {
                            if (self.model.get("membership")) {
                                if (new Number(amount) > new Number(self.currencyModel.get("currencyCredit"))) {
                                    new ModalView({body: "<h1 class='large' style='color: #E8EFF7;text-align: center;font-size: 18px;margin: 30px;'>" + i18n.msg('pos.payment.error.membership') + "</h1>"}).render().$(".modal-footer").hide();
                                    self.$(".mode[data-mode='MEMBER_CARD'] .num").text("0.00");
                                    self.numberpad.clear();
                                    return;
                                }
                            }
                        }

                        self.numberpad.target.find(".num").text(amount);
                        if (self.$('.mode.selected .num.medium').width() > 60 && $('.modeDiv').width() < 190) {
                            self.$('.modeDiv .title-wrapper').addClass('hidden');
                        } else {
                            self.$('.modeDiv .title-wrapper').removeClass('hidden');
                        }
                    }
                    self._updateAmounts();
                },
                _currentPaid: function () {
                    var self = this, amounts = 0;
                    self.payments = self.payments || new Backbone.Model();
                    self.payments.clear();
                    _.each(self.$(".modes .mode"), function (mode) {
                        var $mode = $(mode), data = $mode.data(), amount, numText = $mode.find(".num").text().trim();
                        if (numText) {
                            amount = parseFloat(numText);

                            self.payments.set(data.mode, amount);
                            amounts += amount;
                        }
                    });
                    return Number(amounts);
                },
                _totalPaid: function () {
                    var self = this, amounts = 0;
                    amounts += self.model.get("currentBill").get("paidAmount");
                    amounts += self._currentPaid();
                    return Number(amounts);
                },
                _onSingeDiscountChange: function () {
                    var self = this,
                        bill = self.model.get("currentBill"),
                        sd = self.model.get("singeDiscount");
                    if (!bill) {
                        return;
                    }
                    if (self.model.get('discount')) {
                        self.model.unset('discount');
                        self.model.unset('discountId', {silent: true});
                        self.model.get("currentBill").unset('discount');
                        POS.getTable(self.model.get("tableId")).get("currentBill").unset('discount');
                    }
                    if (sd) {
                        bill.recalculateItemsDiscount();
                        POS.getTable(self.model.get("tableId")).get("currentBill").recalculateItemsDiscount();
                    }
                    self.model.unset("useignore");
                    self.model.unset("usetip");
                    // self.numberpad.clearTarget();
                    bill.calculateAmount();
                    self._updateAmounts();
                    self._updateSingeDiscountHtml(sd ? sd : {});
                },
                _onDiscountChange: function () {
                    var self = this, deferred = $.Deferred(),
                        bill = self.model.get("currentBill"),
                        restaurant = POS.getRestaurant(),
                        discount = POS.get("discountCollection").get(self.model.get("discountId") || 0);
                    if (!bill) {
                        deferred.resolve();
                        return deferred;
                    }
                    if (self.model.get("singeDiscount")) {
                        self.model.get("currentBill").resetItemsDiscount();
                        POS.getTable(self.model.get("tableId")).get("currentBill").resetItemsDiscount();
                        self.model.unset("singeDiscount", {silent: true});
                    }
                    bill.set({discount: discount});
                    POS.getTable(self.model.get("tableId")).get("currentBill").set({discount: discount});
                    self.model.unset("useignore");
                    self.model.unset("usetip");
                    // self.numberpad.clearTarget();
                    self._updateAmounts();
                    _.defer(function () {
                        self._updateDiscountHtml(discount ? DbRecorder.convert2JSON(discount) : {});
                        deferred.resolve();
                    });
                    return deferred;
                },
                _updateSingeDiscountHtml: function (singeDiscount) {
                    var self = this, bill = self.model.get("currentBill");
                    if (!_.isEmpty(singeDiscount)) {
                        self.$(".edit-discount .discount-area").addClass("has-discount");
                        self.$(".edit-discount .discount-area").removeClass("vcenter");
                        self.$(".edit-discount .discount-area").find(".name").text(i18n.msg('pos.settings.discount.singe.order'));
                        self.$(".edit-discount .discount-area").find(".amount").text("-" + POS.getRestaurant().get("currencySymbol") + bill.get("offDiscountAmount").toFixed(2));
                    } else {
                        self.$(".edit-discount .discount-area").removeClass("has-discount");
                        self.$(".edit-discount .discount-area").addClass("vcenter");
                        self.$(".edit-discount .discount-area").find(".name").text("");
                        self.$(".edit-discount .discount-area").find(".amount").text("0.00");
                    }
                    self._checkDiscount();
                },
                _updateDiscountHtml: function (discount) {
                    var self = this, bill = self.model.get("currentBill");
                    if (!_.isEmpty(discount)) {
                        self.$(".edit-discount .discount-area").addClass("has-discount");
                        self.$(".edit-discount .discount-area").removeClass("vcenter");
                        self.$(".edit-discount .discount-area").find(".name").text(discount.name);
                        self.$(".edit-discount .discount-area").find(".amount").text("-" + POS.getRestaurant().get("currencySymbol") + bill.get("offDiscountAmount").toFixed(2));
                        self.$(".edit-discount .discount-area").find(".remove").removeClass('singeDiscount');
                    } else {
                        self.$(".edit-discount .discount-area").removeClass("has-discount");
                        self.$(".edit-discount .discount-area").addClass("vcenter");
                        self.$(".edit-discount .discount-area").find(".name").text("");
                        self.$(".edit-discount .discount-area").find(".amount").text("0.00");
                    }
                    self._checkDiscount();
                },
                _updateTipHtml: function (tipAmount) {
                    var self = this;
                    if (tipAmount > 0) {
                        self.$(".edit-discount .tip-area").addClass("has-discount");
                        self.$(".edit-discount .tip-area").removeClass("vcenter");
                        self.$(".edit-discount .tip-area").find(".amount").text(tipAmount.toFixed(2));
                    } else {
                        self.$(".edit-discount .tip-area").removeClass("has-discount");
                        self.$(".edit-discount .tip-area").addClass("vcenter");
                        self.$(".edit-discount .tip-area").find(".amount").text("0.00");
                    }
                    self._checkDiscount();
                },
                _updateIgnoreHtml: function (ignoreAmount) {
                    var self = this;
                    if (ignoreAmount > 0) {
                        self.$(".edit-discount .ignore-area").addClass("has-discount");
                        self.$(".edit-discount .ignore-area").removeClass("vcenter");
                        self.$(".edit-discount .ignore-area").find(".amount").text(ignoreAmount.toFixed(2));
                    } else {
                        self.$(".edit-discount .ignore-area").removeClass("has-discount");
                        self.$(".edit-discount .ignore-area").addClass("vcenter");
                        self.$(".edit-discount .ignore-area").find(".amount").text("0.00");
                    }
                    self._checkDiscount();
                },
                _onTipChange: function () {
                    var self = this,
                        useTip = self.model.get('usetip'),
                        tipAmount = self.model.get('tipAmount'),
                        tip = useTip ? tipAmount : 0,
                        currencySymbol = POS.getRestaurant().get('currencySymbol'),
                        bill = self.model.get("currentBill"),
                        crtBill = self.model.get("tableId") ? POS.getTable(self.model.get("tableId")).get("currentBill") : null;
                    if (useTip && tip > 0) {
                        self.$(".edit-discount .tip-area").addClass("has-discount");
                        self.$(".edit-discount .tip-area").removeClass("vcenter");
                        self.$(".edit-discount .tip-area").find(".amount").text(tip.toFixed(2));
                    } else {
                        self.$(".edit-discount .tip-area").removeClass("has-discount");
                        self.$(".edit-discount .tip-area").addClass("vcenter");
                        self.$(".edit-discount .tip-area").find(".amount").text("0.00");
                        self.model.unset("tipAmount", {silent: true});
                    }
                    if (bill) {
                        bill.set({tipAmount: tip});
                    }
                    if (crtBill) {
                        crtBill.set({tipAmount: tip});
                    }
                    // self.numberpad.clearTarget();
                    self._checkDiscount();
                    self._updateAmounts();
                },
                _onIgnoreChange: function () {
                    var self = this,
                        useignore = self.model.get("useignore"),
                        ignoreAmount = self.model.get("ignoreAmount"),
                        ignore = useignore ? ignoreAmount : 0,
                        currencySymbol = POS.getRestaurant().get("currencySymbol"),
                        bill = self.model.get("currentBill"),
                        crtBill = self.model.get("tableId") ? POS.getTable(self.model.get("tableId")).get("currentBill") : null;
                    if (useignore && ignore > 0) {
                        if (ignore > self._shouldPay()) {
                            ignore = self._shouldPay();
                        }
                        self.$(".edit-discount .ignore-area").addClass("has-discount");
                        self.$(".edit-discount .ignore-area").removeClass("vcenter");
                        self.$(".edit-discount .ignore-area").find(".amount").text(ignore.toFixed(2));
                    } else {
                        self.$(".edit-discount .ignore-area").removeClass("has-discount");
                        self.$(".edit-discount .ignore-area").addClass("vcenter");
                        self.$(".edit-discount .ignore-area").find(".amount").text("0.00");
                        self.model.unset("ignoreAmount", {silent: true});
                    }
                    if (bill) {
                        bill.set({ignoreAmount: ignore});
                    }
                    if (crtBill) {
                        crtBill.set({ignoreAmount: ignore});
                    }
                    // self.numberpad.clearTarget();
                    self._checkDiscount();
                    self._updateAmounts();
                },
                _checkDiscount: function () {
                    var editDiscount = this.$(".edit-discount"),
                        addDiscount = this.$(".add-discount");
                    if (editDiscount.find(".has-discount").length > 0) {
                        editDiscount.show();
                        addDiscount.hide();
                    } else {
                        editDiscount.hide();
                        addDiscount.show();
                    }
                },
                _tipAmount: function () {
                    var self = this,
                        usetip = self.model.get('usetip'),
                        tip = usetip ? parseFloat(self.$(".tip-area").find(".amount").text()) : 0;
                    return Number(tip.toFixed(2));
                },
                _ignoreAmount: function () {
                    var self = this,
                        useignore = self.model.get("useignore"),
                        ignore = useignore ? parseFloat(self.$(".ignore-area").find(".amount").text()) : 0;
                    return Number(ignore.toFixed(2));
                },
                _calculateIgnore: function () {
                    var self = this, shouldPay = self._shouldPay();
                    return shouldPay - Math.floor(shouldPay);
                },
                _shouldPay: function () {
                    var self = this, bill = self.model.get("currentBill"), shouldPayAmount = 0, feeAmount = 0;
                    if (bill) {
                        shouldPayAmount = bill.get("shouldPayAmount");
                        feeAmount = bill.get('feeAmount');
                    }
                    self.$(".should-pay-amount").text(shouldPayAmount.toFixed(2));
                    self.$(".fee-amount").text(feeAmount.toFixed(2));
                    return shouldPayAmount;
                },
                _leftPay: function (load) {
                    var self = this,
                        amounts = self._currentPaid(),
                        ignore = self._ignoreAmount(),
                        tipAmount = self._tipAmount();
                    return Number((self._shouldPay() - amounts).toFixed(2));
                },

                _updateAmounts: function () {
                    var self = this,
                        amounts = self._currentPaid(),
                        paid = self.$(".paid-amount"),
                        change = self.$(".change-amount"),
                        tip = self.$('.tip-amount');

                    paid.text(amounts.toFixed(2));
                    change.closest(".amount-item").toggleClass("hidden", self._leftPay() >= 0);
                    change.text((0 - self._leftPay()).toFixed(2));
                    tip.text(self._tipAmount());
//                tip.closest(".amount-item").toggleClass("hidden", !self._tipAmount() > 0);
                    if (self._leftPay() <= 0) {
                        $('.cashier-container .btn.pay').removeClass('disabled').attr("disabled", null);
                    } else {
                        $('.cashier-container .btn.pay').addClass('disabled').attr("disabled", "disabled");
                    }
                    self._shouldPay();
                },
                _choosePayMode: function (event) {
                    var self = this, mode = $(event.currentTarget),
                        offlineMsg = i18n.msg("pos.membership.offline"),
                        msg = i18n.msg("pos.payment.over.pay"),
                        left = mode.data("mode") == "MEMBER_CARD" ? 0 : mode.data("mode") == "OTHER_PAY" ? 0 : self._leftPay();
                    self.numberpad.changeTarget(mode, null, left);
                    if (mode.data("mode") == "MEMBER_CARD") {
                        if (!DbRecorder.getStatusModel().get("online")) {
                            new ModalView({
                                hideFooter: true,
                                body: "<h1 class='large' style='color: white; text-align: center;'>" + offlineMsg + "</h1>"
                            }).render();
                            return;
                        }
                        self._showMembershipModal();
                    } else if (mode.data("mode") == "OTHER_PAY") {
                        if (!DbRecorder.getStatusModel().get("online")) {
                            new ModalView({
                                hideFooter: true,
                                body: "<h1 class='large' style='color: white; text-align: center;'>" + offlineMsg + "</h1>"
                            }).render();
                            return;
                        }
                        self._showPaymentSelectedModal();
                    }
                    self.showCalculatorView();
                },

                _checkBillMembership: function () {
                    var jxhr, self = this;
                    if (!self.model.get('billId')) {
                        return;
                    }
                    jxhr = $.post("/membership/checkBillMembership", {billId: self.model.get('billId')});
                    jxhr.done(function (response) {
                        if (response.success) {
                            self.model.unset('membershipid', {silent: true});
                            self.model.set({
                                membership: response.membership,
                                membershipid: response.membership.id
                            });
                        }
                    });
                    jxhr.fail(function (response) {

                    });
                },
                _showMembershipModal: function () {
                    var self = this, restaurant = POS.getRestaurant();
                    var membershipSelectorEl = $(Membership_selectorView({
                        currencySymbol: restaurant.get("currencySymbol"),
                        hasWeixinLicense: POS.checkFeature("WEIXIN_RESTAURANT")
                    }));
                    if (self.model.get("membershipid")) {
                        self.model.unset("membership");
                        self.model.unset("membershipid");
                        self.model.unset("recode");
                    }
                    self.model.set("membershipModalIsShow", true);
                    self.membershipSelectorView = new MembershipSelectorView({
                        el: membershipSelectorEl,
                        model: self.model
                    });
                    var modalView = new ModalView({body: membershipSelectorEl, hideFooter: true}).render();
                    modalView.$el.find('.membership-input').focus();
                    modalView.listenTo(self.model, "change:closemembership", function () {
                        modalView.close();
                        self.model.unset("closemembership");
                    });

                    self.listenTo(modalView, "closed", function () {
                        self.model.set("membershipModalIsShow", false);
                        if (self.model.get("membership") == null) {
                            self.numberpad.changeTarget(self.$(".list-group .mode[data-mode='CASH']"), null);
                        }
                    });
                },
                _showPaymentSelectedModal: function () {
                    var self = this, restaurant = POS.getRestaurant(), params = {
                        used: {}
                    };
                    _.each(restaurant.get("defaultPaymentMethods"), function (method) {
                        if (method.inUse) {
                            params.used[method.method] = method.method;
                        }
                    });
                    params.customPayments = POS.get("customPayments");
                    var paymentSelectorEl = $(Payment_selectorView(params));

                    self.model.set("paymentModalIsShow", true);
                    self.paymentSelectorView = new PaymentSelectorView({
                        el: paymentSelectorEl,
                        model: self.model,
                        numberpad: self.numberpad,
                        leftPay: self._leftPay()
                    });
                    var modalView = new ModalView({
                        hideHeader: true,
                        body: paymentSelectorEl,
                        hideFooter: true
                    }).render();
                    modalView.listenTo(self.model, "change:closePayment", function () {
                        modalView.close();
                        self.model.unset("closePayment", {silent: true});
                        if (self.model.get('chooseMode').data('mode') == "MEMBER_CARD") {
                            if (!DbRecorder.getStatusModel().get("online")) {
                                new ModalView({
                                    hideFooter: true,
                                    body: "<h1 class='large' style='color: white; text-align: center;'>" + offlineMsg + "</h1>"
                                }).render();
                                return;
                            }
                            self._showMembershipModal();
                        }
                    });

                    self.listenTo(modalView, "closed", function () {
                        self.model.set("paymentModalIsShow", false);
                    });
                },
                _calculateMembership: function (membership) {
                    var params = {}, supportCurrencies = [], self = this;
                    self.currencyModel = new Backbone.Model();
                    _.each(POS.get("payRule"), function (rule) {
                        if (rule.posPayable) {
                            self.currencyModel.set('currency', rule.currency);
                            var currency = rule.currency;
                            if (supportCurrencies.length === 0) {
                                currency.selected = true;
                            }
                            supportCurrencies.push(currency);
                        }
                    });
                    params.supportCurrencies = supportCurrencies;
                    var currencyChooseEl = $(Currency_choose(params)),
                        leftPay = self._leftPay();
                    var currencyChooseSelector = new CurrencySelectorView(
                        {
                            el: currencyChooseEl,
                            membership: membership,
                            model: self.currencyModel,
                            shouldPay: leftPay,
                            supportCurrencies: supportCurrencies,
                            items: self.model.get('currentOriginalBill').get('items').toJSON()
                        }
                    );
                    var modalView = new ModalView({
                        body: currencyChooseEl,
                        hideFooter: true,
                        hideHeader: true
                    }).render();
                    modalView.$el.find(".modal-content").addClass("currencyChooseModal");
                    modalView.listenTo(self.currencyModel, "change:membershipPay", function (params) {
                        console.log(self.currencyModel);
                        if (self.currencyModel.get('basicPay')) {
                            self._basicPayBill();
                            self.model.set({closemembership: true});
                            modalView.close();
                        } else {
                            self.membershipProcess(membership);
                            self.model.set({closemembership: true});
                            modalView.close();
                        }
                    });
                    // modalView.listenTo(modalView, "closed", function () {
                    //     if (!self.currencyModel.get("creditEnough")) {
                    //         if (self.model.get('membership').scheme.discount) {
                    //             self.model.unset('discount');
                    //             self.model.unset('discountId');
                    //         }
                    //         self.model.unset('membership');
                    //         self.model.unset('membershipid');
                    //     }
                    // })
                },
                membershipProcess: function (membership) {
                    var self = this, leftPay = 0, credit = self.currencyModel.get("currencyCredit"), membershipPayment = 0,
                        mode = self.$(".member-info").closest(".mode");
                    // self.$(".member-info .member-name").text(membership.name);
                    membershipPayment = Number(self.currencyModel.get("membershipPayment"));
                    leftPay = self._leftPay();
                    if (self.currencyModel.get("membershipPay")) {
                        if (membershipPayment == 0) {
                            mode.find(".num").text(Number(0).toFixed(2));
                        } else if (credit >= leftPay) {
                            mode.find(".num").text(leftPay.toFixed(2));
                        } else if (credit < leftPay) {
                            mode.find(".num").text(credit.toFixed(2));
                        } else {
                            mode.find(".num").text(credit.toFixed(2));
                        }
                        self.numberpad.changeTarget(mode, membership, self._leftPay());
                    }
                },

                _onMembershipChange: function () {
                    var self = this,
                        membership = self.model.get("membership"),
                        mode = self.$(".member-info").closest(".mode");
                    if (membership) {
                        if (membership.scheme.discount) {
                            self.model.set({
                                discountId: membership.scheme.discount.id,
                                discount: membership.scheme.discount
                            });
                            self._onDiscountChange().done(function () {
                                if (self.model.get('recode')) {
                                    self.model.set({closemembership: true});
                                } else {
                                    self._calculateMembership(membership);
                                }
                            });
                        } else {
                            if (self.model.get('recode')) {
                                self.model.set({closemembership: true});
                            } else {
                                self._calculateMembership(membership);
                            }
                        }

                    } else {
                        self.numberpad.changeTarget(self.$(".modes .mode:first"), null, self._leftPay());
                        mode.find(".num").text("");
                        self._updateAmounts();
                    }
                    self.$(".member-info").toggleClass("hidden", !membership);
                }
                ,
                _updateIgnore: function (event) {
                    var self = this, ignoreEl = $(event.currentTarget);
                    self.numberpad.changeTarget(ignoreEl, null, self._leftPay());
                }
                ,
                _removeIgnore: function (event) {
                    var self = this;
                    self.model.unset("useignore");
                    return false;
                }
                ,
                _removeTip: function () {
                    var self = this;
                    self.model.unset("usetip");
                    return false;
                }
                ,
                _removeDiscount: function (event) {
                    var self = this;
                    if ($(event.currentTarget).hasClass("singeDiscount")) {
                        self.model.get("currentBill").resetItemsDiscount();
                        POS.getTable(self.model.get("tableId")).get("currentBill").resetItemsDiscount();
                        self.model.unset("singeDiscount");
                    }
                    self.model.unset("discount");
                    self.model.unset("discountId");
                    self._onTableChange();
                    return false;
                }
                ,
                _removeWaiter: function (evt) {
                    var self = this,
                        bill = self.model.get('currentBill'), originalBill = self.model.get('currentOriginalBill');
                    bill.set({waiter: null});
                    originalBill.set({waiter: null});
                    self.waiter = null;
                    $(evt.currentTarget).closest('.show-waiter').hide().siblings('.add-waiter').show();
                    return false;
                }
                ,
                _removeNote: function (event) {
                    var self = this, tableId = self.model.get("tableId"), table;
                    table = POS.getTable(tableId);
                    table.get("currentBill").set({note: null, noteBytes: null});
                    self.note = null;
                    $(event.currentTarget).closest('.pay-notes').hide().siblings('.add-btn').show();
                    return false;
                }
                ,
                _switchTable: function () {
                    if (this.tableSelectModalView) {
                        this.tableSelectModalView.remove();
                    }
                    this.tableSelectModalView = new TableSelectModalView({
                        collection: new Backbone.Collection(POS.getOrderingTables()),
                        currentTable: POS.getTables().get(this.model.get("tableId"))
                    });
                    this.listenTo(this.tableSelectModalView, "selectTable", this._onChangeTable);
                    // this.listenTo(this.tableSelectModalView, "closeSelect", this.onSelectClose);
                    this.tableSelectModalView.render(POS.getTables().get(this.model.get("tableId")));
                }
                ,
                _showDiscounts: function () {
                    var self = this, symbol = POS.getRestaurant().get("currencySymbol"),
                        discounts = _.map(POS.get("discountCollection").getValidDiscounts(), function (model) {
                            var json = model.toJSON();
                            json._off = (json.type == "Amount") ? (symbol + json.off) : (json.off + "%");
                            return json;
                        });
                    var discountSelectorEl = $(Discount_selectorView({
                        discounts: discounts,
                        admins: POS.getRestaurantAdmins()
                    }));
                    this.discountSelector = new DiscountSelectorView({el: discountSelectorEl, model: self.model});
                    var modalView = new ModalView({
                        body: discountSelectorEl,
                        hideFooter: true,
                        hideHeader: false,
                        title: i18n.msg("pos.modal.header.select.discount")
                    }).render();
                    modalView.listenToOnce(self.model, "change:discountId", modalView.close, modalView);
                    modalView.listenToOnce(self.model, "change:useignore", modalView.close, modalView);
                    modalView.listenToOnce(self.model, "change:usetip", modalView.close, modalView);
                    $(".discount-selector").eq($(".discount-selector").length - 1).parents().eq(3).focus()
                },
                _showAddNotes: function () {
                    var offlineMsg = i18n.msg("pos.note.offline");
                    if (!DbRecorder.getStatusModel().get("online")) {
                        new ModalView({
                            hideFooter: true,
                            body: "<h1 class='large' style='color: white; text-align: center;'>" + offlineMsg + "</h1>"
                        }).render();
                        return;
                    } else {
                        this.noteSelectorView = this.noteview;
                        this.noteSelectorView.once("noteSelected", function (note) {
                            POS.getTable(self.model.get("tableId")).get("currentBill").set({
                                note: note.note,
                                noteBytes: note.noteBytes
                            });
                            self.model.get("currentBill").set({note: note.note, noteBytes: note.noteBytes});
                            self.note = note.note;
                            self.noteSelectorView.$el.modal("hide");
                            self.$(".add-btn").hide();
                            self.$(".pay-notes").show().css('display', 'block').find(".content").text(note.note).show();
                            self.noteSelectorView.clear();
                        });
                        var self = this;

                        this.note = "";
                        this.noteSelectorView.$el.modal("show");
                        var currentNote = $('#cashier').find('.pay-notes .content').text();
                        this.$("textarea.note").val(currentNote);
                    }
                }
                ,
                _checkKey: function (event) {
                    var self = this, keyCode = event.keyCode;
                    if (keyCode == 13) {
                        self.$(".btn.pay").click();
                    }
                }
                ,

                showLoading: function (isShown) {
                    if (isShown) {
                        $('#bigLoading').removeClass('hidden');
                    } else {
                        $('#bigLoading').addClass('hidden');
                    }
                }
                ,
                _payBillNoChange: function () {
                    var self = this, tipAmount = 0, change = self.$(".change-amount"), tip = self.$('.tip-amount');
                    tipAmount = parseFloat(change.text()) + parseFloat(tip.text());
                    self.model.unset('usetip', {silent: true});
                    self.model.set({usetip: true, tipAmount: tipAmount});
                    change.closest(".amount-item").addClass("hidden");
                    change.text(0);
                }
                ,
                _basicPayBill: function () {
                    var self = this;
                    const TOOIE = window.TOOIE_INIT_PARAMS;
                    if (TOOIE.isExpRest) {
                        _mp("V完成结账");
                    }
                    self.showLoading(true);
                    if (self.processing) {
                        self.showLoading(false);
                        return;
                    }

                    this.processing = true;
                    var printSetting = POS.getPrinterSetting(),
                        tableId = self.model.get("tableId"),
                        table = POS.get("tableCollection").get(tableId),
                        originalBill = self.model.get("currentOriginalBill"),
                        note = self.$(".note").val(),
                        jxhr,
                        amount = self.currencyModel.get('membershipPayment'),
                        preNote = originalBill.get("note"),
                        payment,
                        membership = self.model.get("membership"),
                        restaurant = POS.getRestaurant();
                    originalBill.calculateAmount();
                    if (membership) {
                        originalBill.set({membership: membership});
                    }
                    if (self.currencyModel.get('membershipPay')) {
                    }
                    var paymentParams = {method: 'MEMBER_CARD', amount: amount, original: amount};
                    if (self.currencyModel.get('membershipPay')) {
                        paymentParams.currency = self.currencyModel.get('currency');
                        payment = new Backbone.Model(paymentParams);
                    }
                    _.each(originalBill.getConfirmedItems(), function (item) {
                        if (item.getOrderedQuantity() > 0) {
                            item.set({paid: true});
                        }
                    });
                    var params = {
                        restaurantId: restaurant.id,
                        billId: originalBill.id,
                        currencyId: self.currencyModel.get('currencyId'),
                        waiter: originalBill.get('waiter') ? JSON.stringify(originalBill.get('waiter')) : null,
                        note: note,
                        pays: JSON.stringify(payment.toJSON()),
                        membershipId: membership ? membership.id : 0,
                        dinerCount: originalBill.get("dinerCount"),
                        payDate: originalBill.get("payDate"),
                        bookingId: originalBill.get('booking') ? originalBill.get('booking').id : null
                    };
                    jxhr = $.post("/pos/basicPayBill", params);
                    jxhr.done(function (response) {
                        if (response.success) {
                            delete self.processing;
                            self.showLoading(false);
                            originalBill.set({status: "Paid", payStatus: "Paid"});
                            originalBill.setPayDate();
                            preNote && note && (note = preNote + note);
                            note && originalBill.set({note: note});
                            table.set({paidTime: new Date().getTime()});
                            var printBill = new BillModel(response.bill);
                            table.createNewBill();
                            printBill.getRefundAmount();
                            var billDetail = DbRecorder.convert2JSON(printBill);
                            if (restaurant.get('fastFood')) {
                                billDetail.fastfood = true;
                            }
                            billDetail.table = table.toJSON();
                            if (printSetting.get("paymentReceipt")) {
                                PrintService.printCashierReceipt(billDetail);
                                // PrintService.printMembershipInfoReceipt(billDetail);
                            }
                            // PrintService.openCashbox();
                            self.model.clear();
                            if (restaurant.get('fastFood')) {
                                Backbone.history.navigate("etable/" + tableId, {trigger: true});
                            } else {
                                Backbone.history.navigate("table/" + tableId, {trigger: true});
                            }
                            LogUtil.info('CashierView', 'completePayment');
                        }
                    })
                    ;
                    jxhr.fail(function (response) {

                    });
                },
                _payBill: function () {
                    console.log("1公开：", this.$('.isPublic').prop('checked'));

                    const TOOIE = window.TOOIE_INIT_PARAMS;
                    if (TOOIE.isExpRest) {
                        _mp("V完成结账");
                    }
                    this.showLoading(true);
                    _.defer(_.bind(function () {
                        if (this.processing) {
                            this.showLoading(false);
                            return;
                        }
                        this.processing = true;
                        var self = this;
                        var payBtn = self.$(".btn.pay");
                        var tableId = self.model.get("tableId");
                        var printSetting = POS.getPrinterSetting();
                        // 当前桌台
                        var table = POS.get("tableCollection").get(tableId);
                        var bill = self.model.get("currentBill");
                        var originalBill = self.model.get("currentOriginalBill");
                        var note = self.$(".note").val();
                        var preNote = originalBill.get("note");
                        var payments = originalBill.get("payments");
                        var discount = POS.get("discountCollection").get(self.model.get("discountId"));
                        var membership = self.model.get("membership");
                        var ignore = self._ignoreAmount();
                        var tip = self._tipAmount();
                        var customPayments = POS.get("customPayments");
                        var restaurant = POS.getRestaurant();
                        if (self._leftPay() > 0) {
                            var msg = i18n.msg("pos.payment.error");
                            var leftPayRemind = new ModalView({
                                title: '提示',
                                body: "<div class='large' style='color: #697A93;font-size: 18px; text-align: center; line-height: 87px'>" + msg + "</div>"
                            }).render();
                            leftPayRemind.$(".modal-footer").hide();
                            leftPayRemind.$el.find('.modal-title').addClass('leftPayRemind-title');
                            delete this.processing;
                            this.showLoading(false);
                            return;
                        }


                        if (discount) {
                            originalBill.set({discount: discount});
                        }
                        if (bill.get('taxId') && bill.get('taxId').length > 0) {
                            originalBill.set({taxId: bill.get('taxId')});
                        }
                        originalBill.calculateAmount();
                        if (membership) {
                            originalBill.set({membership: membership});
                        }

                        _.each(self.payments.toJSON(), function (amount, method) {
                            var params = {};
                            if (amount != 0) {
                                params = {method: method, amount: amount, original: amount};
                                if (method == "MEMBER_CARD") {
                                    //会员卡可以付款0，我们用来绑定账单和会员，以方便记录客户消费
                                    if (self.currencyModel.get('membershipPay')) {
                                        params.currency = self.currencyModel.get('currency');
                                        params.currencyId = self.currencyModel.get('currencyId');
                                        //params.membershipPayment = self.currencyModel.get('membershipPayment');
                                    }
                                }
                                if (customPayments && customPayments.length > 0) {
                                    _.each(customPayments, function (payment) {
                                        if (payment.mode == method) {
                                            params.customPayment = payment;
                                        }
                                    });
                                    // params.customPayment = customPayments
                                }
                                payments.add(params);
                            }
                        });
                        if (ignore) {
                            payments.add({method: "IGNORE", amount: ignore, original: ignore});
                            originalBill.set({ignoreAmount: ignore});
                            originalBill.calculateAmount();
                        }
                        if (tip) {
                            payments.add({method: 'TIP', amount: tip, original: tip});
                            originalBill.set({tipAmount: tip});
                            originalBill.calculateAmount();
                        }

                        if (payments.length < 1) {
                            payments.add({method: "IGNORE", amount: 0, original: 0});
                        }
                        if (originalBill.get("roundAmount") != 0) {
                            payments.add({
                                method: "ROUND",
                                amount: parseFloat(originalBill.get("roundAmount")),
                                original: parseFloat(originalBill.get("roundAmount"))
                            });
                        }
                        _.each(originalBill.getConfirmedItems(), function (item) {
                            if (item.getOrderedQuantity() > 0) {
                                item.set({paid: true});
                            }
                        });
                        originalBill.set({status: "Paid", payStatus: "Paid"});
                        originalBill.setPayDate();
                        preNote && note && (note = preNote + note);
                        note && originalBill.set({note: note});
                        table.set({paidTime: new Date().getTime()});
                        table.createNewBill();
                        originalBill.getRefundAmount();

                        var billDetail = DbRecorder.convert2JSON(originalBill);
                        if (restaurant.get('fastFood')) {
                            billDetail.fastfood = true;
                        }
                        billDetail.table = table.toJSON();
                        if (printSetting.get("paymentReceipt")) {
                            PrintService.printCashierReceipt(billDetail);
                            _.delay(function () {
                                PrintService.printMembershipInfoReceipt(billDetail)
                            }, 5000)
                        }
                        // PrintService.openCashbox();
                        self.model.clear();
                        if (restaurant.get('fastFood')) {
                            Backbone.history.navigate("etable/" + tableId, {trigger: true});
                        } else {
                            Backbone.history.navigate("table/" + tableId, {trigger: true});
                        }
                        LogUtil.info('CashierView', 'completePayment');
                        delete this.processing;
                        this.showLoading(false);
                    }, this));
                }
                ,
                _printBillInTab: function (evt) {
                    var self = this, bill, printActionsView,
                        //cid = $(evt.currentTarget).data("cid");//待确认
                        cid = $(".print-invoice").data("cid");
                    bill = self.model.get("currentOriginalBill");
                    self.model.set({cashierView: true});
                    printActionsView = new BillPrintActionsView({
                        bill: bill,
                        table: POS.getTable(self.model.get("tableId")),
                        model: self.model,
                        el: self.printEL
                    });
                    var printActionsViewModal = new ModalView({
                        body: printActionsView.el,
                        title: i18n.msg("pos.printer.receipt.type.selection.label"),
                        save: i18n.msg("pos.label.print")
                    }).render();
                    printActionsViewModal.$el.find(".modal-content").addClass("printActionModal");
                    printActionsViewModal.$el.find(".btn-confirm").addClass("printAction");
                    printActionsViewModal.model.on("change:confirmedTime", function () {
                        printActionsView._print();
                        printActionsViewModal.close();
                    });
                    printActionsViewModal.model.on("change:closeTime", function () {
                        printActionsViewModal.close();
                    });
                }
                ,
                _selectWaiter: function (staff) {
                    var self = this,
                        bill = self.model.get('currentBill'), originalBill = self.model.get('currentOriginalBill');
                    $('.add-waiter').hide().siblings('.show-waiter').css('display', 'inline-table').show().find('.name').text(staff.name);
                    bill.set({waiter: staff});
                    originalBill.set({waiter: staff});
                    this.chooseMemberModalView.hide();
                }
                ,
                chooseWaiter: function () {
                    this.chooseMemberModalView = new ChooseMemberModalView({type: "STAFF"});
                    this.chooseMemberModalView.show();
                    this.listenToOnce(this.chooseMemberModalView, 'chooseStaff', this._selectWaiter);
                }
                ,

                showBillView: function () {
                    this.$('.functionTabs span').removeClass('selected');
                    this.$('.functionTabs .billView').addClass('selected');
                    this.$(".cashier-right").removeClass('expanded').addClass('minimize');
                    this.$(".cashier-left").addClass('expanded');
                }
                ,

                showDiscountView: function () {
                    this.$('.functionTabs span').removeClass('selected');
                    this.$('.functionTabs .discountView').addClass('selected');

                    this.$(".cashier-right").removeClass('minimize').addClass('expanded');
                    this.$(".cashier-left").removeClass('expanded');
                    this.$(".cashier-checkout").addClass('minimize');
                    this.$(".cashier-main").addClass('expanded');
                }
                ,

                showCalculatorView: function () {
                    this.$('.functionTabs span').removeClass('selected');
                    this.$('.functionTabs .calculatorView').addClass('selected');

                    this.$(".cashier-right").removeClass('minimize');
                    this.$(".cashier-left").removeClass('expanded');
                    this.$(".cashier-checkout").removeClass('minimize');
                    this.$(".cashier-main").removeClass('expanded');
                }
            }
        )
            ;
    }
;

let exportedValue = main();
export default exportedValue;




// WEBPACK FOOTER //
// ./src/view/cashier/CashierView.js